/** Элемент jsResult.states с полями сериализации VisualElementState. */
export interface OverlayVisibilityState {
  element_id?: number | string
  element_name?: string
  element_level?: string
  is_visible?: boolean
}

/** Проверяет, что onClick содержит en.setVisible для overlay по имени. */
export function scriptMentionsOverlaySetVisible(code: string, overlayName: string): boolean {
  if (!code || !overlayName) return false
  return (
    code.includes(`setVisible("${overlayName}"`) ||
    code.includes(`setVisible('${overlayName}'`) ||
    code.includes(`setVisible(\`${overlayName}\``)
  )
}

export function scriptMentionsDispatchVisibility(code: string): boolean {
  if (!code) return false
  return /dispatchVisibility\s*\(/.test(code)
}

export function serverStateIncludesOverlay(
  states: OverlayVisibilityState[] | undefined,
  overlayName: string,
  overlayId: string,
): boolean {
  return (states ?? []).some((state) => {
    const level = String(state.element_level ?? '').toUpperCase()
    if (level !== 'OVERLAYPAGE') return false
    if (state.element_name === overlayName) return true
    if (overlayId && state.element_id != null && String(state.element_id) === overlayId) {
      return true
    }
    return false
  })
}
